import { FC } from 'react';

import { useNewInsuranceCoverage } from 'features/Insurance/hooks/useNewInsuranceCoverage';

import PageWrapper from '../../../components/PageWrapper';
import CompleteGuaranteesList from '../../../components/PageWrapper/components/CompleteGuaranteesList';
import offers from '../../../offers';
import * as routes from '../../../routes';
import { AssuredBy } from '../../../types';
import cover from '../assets/phishingCover.png';
import locales from './locales';

const OFFER_NAME = 'Phishing';
const PAGE_NAME = `Insurance${OFFER_NAME.replaceAll(' ', '')}OfferDetails Viewed`;

const Phishing: FC = () => {
  const { coverage, routeState } = useNewInsuranceCoverage();

  const { isCovered, isCoveredFromPlan } = coverage.phishing;

  const guarantees = locales.content;

  return (
    <PageWrapper
      assuredBy={AssuredBy.Shine}
      backButtonLink={routes.coverage}
      coverImage={cover}
      from={routeState.from}
      intercomMessage={locales.claimButton.intercomMessage}
      isCovered={isCovered}
      isCoveredFromPlan={isCoveredFromPlan}
      offer={offers.phishing}
      offerName={OFFER_NAME}
      pageName={PAGE_NAME}
      similarOffers={[offers.legalAssistance, offers.paymentFraud]}
    >
      <CompleteGuaranteesList guarantees={guarantees} />
    </PageWrapper>
  );
};

export default Phishing;
